import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { Partner, PartnerQueryParams, PartnerVoucher } from "../types";

interface PartnerState {
	partnerList: Array<Partner>;
	partnerVoucherList: Array<PartnerVoucher>;
	partnerDetail: Partner;
	partnerTotal: number;
	partnerVoucherTotal: number;
}

export const initialState: PartnerState = {
	partnerList: [],
	partnerVoucherList: [],
	partnerDetail: {
		_id: "",
		name: "",
		address: "",
		mapLink: "",
		latitude: 0,
		longitude: 0,
		status: null,
	},
	partnerTotal: 0,
	partnerVoucherTotal: 0,
};

export const partnerSlice = createSlice({
	name: "partner",
	initialState,
	reducers: {
		setListPartner: (state, action) => {
			state.partnerList = action.payload.data;
			state.partnerTotal = action.payload.total;
		},
		setListPartnerVoucher: (state, action) => {
			state.partnerVoucherList = action.payload.data;
			state.partnerVoucherTotal = action.payload.total;
		},
		setDetailPartner: (state, action) => {
			state.partnerDetail = action.payload.data;
			// update list partners
			state.partnerList = state.partnerList.map(partner => {
				if (partner._id === action.payload.data._id) {
					partner = action.payload.data;
				}
				return partner;
			});
		},
		resetDetailPartner: state => {
			state.partnerDetail = initialState.partnerDetail;
		},
		resetPartnerVouchers: state => {
			state.partnerVoucherList = initialState.partnerVoucherList;
			state.partnerVoucherTotal = initialState.partnerVoucherTotal;
		},
	},
});

export const selectPartnerList = (state: RootState) =>
	state.partner.partnerList;
export const selectPartnerVoucherList = (state: RootState) =>
	state.partner.partnerVoucherList;
export const selectPartnerTotal = (state: RootState) =>
	state.partner.partnerTotal;
export const selectPartnerVoucherTotal = (state: RootState) =>
	state.partner.partnerVoucherTotal;
export const selectPartnerDetail = (state: RootState) =>
	state.partner.partnerDetail;
export const {
	setListPartner,
	setDetailPartner,
	resetDetailPartner,
	setListPartnerVoucher,
	resetPartnerVouchers,
} = partnerSlice.actions;

export interface GetListPartnerAsyncPayload {
	query: PartnerQueryParams;
	callback?: () => void;
}

export interface GetListPartnerVoucherAsyncPayload {
	voucherId: string;
	query: PartnerQueryParams;
	callback?: () => void;
}

export const getListPartnerAsync = createAction(
	"partner",
	(payload: GetListPartnerAsyncPayload) => ({
		payload,
	}),
);

export const getListPartnerVoucherAsync = createAction(
	"partnerVoucher",
	(payload: GetListPartnerVoucherAsyncPayload) => ({
		payload,
	}),
);

export interface UpdatePartnerVoucherAsyncPayload {
	voucherId: string;
	partnerIds: string[];
	callback?: () => void;
}

export const updatePartnerVoucherAsync = createAction(
	"updatePartnerVoucher",
	(payload: UpdatePartnerVoucherAsyncPayload) => ({
		payload,
	}),
);

export interface RemovePartnerVoucherAsyncPayload {
	id: string;
	callback?: () => void;
}

export const removePartnerVoucherAsync = createAction(
	"removePartnerVoucher",
	(payload: RemovePartnerVoucherAsyncPayload) => ({
		payload,
	}),
);

export interface GetPartnerPayload {
	_id: string;
	callback?: Function;
}

export const getPartnerAsync = createAction(
	"partnerDetail",
	(payload: GetPartnerPayload) => ({
		payload,
	}),
);

export interface UpdatePartnerPayload {
	_id: string;
	partner: Partial<Partner>;
	callback?: Function;
}

export const updatePartnerAsync = createAction(
	"updatePartner",
	(payload: UpdatePartnerPayload) => ({ payload }),
);

export interface CreatePartnerPayload {
	partner: Partner;
	callback?: Function;
}

export const createPartnerAsync = createAction(
	"createPartner",
	(payload: CreatePartnerPayload) => ({ payload }),
);

export default partnerSlice.reducer;
